module.exports = __webpack_public_path__ + "media/images/item/rate_3-ddac88b3caf4e0823d23e1a8a660357d.png";